/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';

import defaultAvatar from '../../../../../assets/images/default-avatar-store.png';

class Item extends Component {
  onPress = () => {
    this.props.onPressItem(this.props.id);
  }

  render() {
    const { name, avatarUrl, address } = this.props.item;

    return (
      <div className="item" onClick={this.onPress}>
        <img src={avatarUrl || defaultAvatar} alt="" className="avatar" />
        <div className="info">
          <h3>{name}</h3>
          <p>{`${address.logradouro}, ${address.number}, ${address.bairro}, ${address.cidade} - ${address.uf}`}</p>
        </div>
      </div>
    );
  }
}

export default Item;
